import { action, computed, makeAutoObservable, observable } from "mobx";

class DialogStore {
    private _showDialog: boolean = false;
    private _title: string = "";
    private _message: string = "";
    private _onConfirm?: () => void;
    private _yesText: string = "Yes";
    private _noText: string = "No";
    @observable private _node?: () => React.ReactNode | undefined;

    constructor() {
        makeAutoObservable(this);
    }

    @action showAlert(
        title: string = "Confirm",
        message: string,
        onConfirm: () => void,
        yesText: string = "Yes",
        noText: string = "No",
        node?: () => React.ReactNode,
    ) {
        this._showDialog = true;
        this._title = title;
        this._message = message;
        this._onConfirm = onConfirm;
        this._yesText = yesText;
        this._noText = noText;
        this._node = node;
    }

    @action onClose() {
        this._showDialog = false;
    }

    @action onConfirm() {
        this._onConfirm?.();
        this._showDialog = false;
    }

    @computed get showDialog() {
        return this._showDialog;
    }

    @computed get title() {
        return this._title;
    }

    @computed get message() {
        return this._message;
    }

    @computed get yesText() {
        return this._yesText;
    }

    @computed get noText() {
        return this._noText;
    }

    node() {
        return this._node?.();
    }
}

export default new DialogStore();
